<template>
  <div class="notification-dropdown">
    <el-dropdown trigger="click" placement="bottom-end" @visible-change="handleDropdownVisibleChange">
      <div class="notification-trigger">
        <svg-icon icon-class="bell-fill" class="bell-icon" />
        <el-badge :value="unreadCount" :hidden="unreadCount === 0" class="notification-badge">
        </el-badge>
      </div>

      <el-dropdown-menu slot="dropdown" class="notification-menu" :style="{ width: '320px' }">
        <div class="notification-header">
          <span class="notification-title">Thông báo</span>
          <el-button v-if="unreadCount > 0" type="text" size="mini" @click="markAllAsRead" class="mark-all-read-btn">
            Đánh dấu tất cả đã đọc
          </el-button>
        </div>

        <div class="notification-list" v-loading="loading">
          <div v-for="notification in notifications" :key="notification.id" class="notification-item"
            :class="{ 'unread': !notification.is_read }" @click="markAsRead(notification)">
            <div class="notification-content">
              <div class="notification-message">{{ notification.message }}</div>
              <div class="notification-time">{{ formatTime(notification) }}</div>
              <a :href="notification.url" target="_blank">
                Xem chi tiết
              </a>
            </div>
            <div class="notification-actions">
              <el-button type="text" size="mini" icon="el-icon-close" @click.stop="removeNotification(notification.id)"
                class="remove-btn">
              </el-button>
            </div>
          </div>

          <div v-if="notifications.length === 0" class="empty-notifications">
            <el-empty description="Không có thông báo nào" :image-size="80">
            </el-empty>
          </div>
        </div>

        <div class="notification-footer" v-if="notifications.length > 0">
          <el-button type="text" size="small" @click="clearAllNotifications" class="clear-all-btn">
            Xóa tất cả
          </el-button>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDistanceToNow, parse } from 'date-fns'
import { vi } from 'date-fns/locale'
import { notifyUser } from '@/utils/websocket_notification';

export default {
  name: 'NotificationDropdown',
  data() {
    return {
      loading: false,
      dropdownVisible: false
    }
  },
  computed: {
    ...mapGetters('notifications', ['notifications', 'unreadCount']),
    ...mapGetters(['userId'])
  },
  mounted() {
    this.loadNotifications()
    this.connectWebSocket()
  },
  beforeDestroy() {
    this.disconnectWebSocket()
  },
  methods: {
    ...mapActions('notifications', [
      'loadNotifications',
      'markAsRead',
      'markAllAsRead',
      'removeNotification',
      'clearAllNotifications',
      'addNotification'
    ]),

    handleDropdownVisibleChange(visible) {
      this.dropdownVisible = visible
    },
    parseAsUtc(s) {
      if (typeof s !== 'string') return null;

      const d = parse(s.trim(), 'HH:mm dd/MM/yyyy' , new Date());
      if (isNaN(d.getTime())) return null;
      return new Date(Date.UTC(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes(),
        d.getSeconds(),
        d.getMilliseconds()
      ));
    },
    parseNotificationDate(input) {

      console.log(input)
      const value = (input && typeof input === 'object') ? (input.created_at) : input
      if (!value) return null

      if (value instanceof Date && !isNaN(value.getTime())) return value
      if (typeof value === 'number') {
        const numDate = new Date(value)
        return isNaN(numDate.getTime()) ? null : numDate
      }

      return this.parseAsUtc(value)
    },

    formatTime(date) {
      try {
        const parsedDate = this.parseNotificationDate(date)
        if (!parsedDate) return 'Vừa xong'
        return formatDistanceToNow(parsedDate, {
          addSuffix: true,
          locale: vi
        })
      } catch (error) {
        return 'Vừa xong'
      }
    },

    connectWebSocket() {
      // Connect to websocket for real-time notifications
      const WebSocketManager = require('@/utils/websocket').default

      this.wsConnection = WebSocketManager.connect('notification', this.userId, {
        onMessage: (data) => {
          this.handleWebSocketMessage(data)
        },
        onOpen: () => {
          console.log('Notification WebSocket connected')
        },
        onClose: () => {
          console.log('Notification WebSocket disconnected')
        },
        onError: (error) => {
          console.error('Notification WebSocket error:', error)
        }
      })
    },

    disconnectWebSocket() {
      if (this.wsConnection && this.userId) {
        const WebSocketManager = require('@/utils/websocket').default
        WebSocketManager.disconnect(`notification_${this.userId}`, this.wsConnection)
      }
    },

    handleWebSocketMessage(data) {
      if (data.type === 'notification') {
        this.addNotification({
          id: data.id || Date.now(),
          message: data.message,
          type: data.notification_type || 'info', // Use 'type' instead of 'notification_type'
          url: data.url ?? null,
          is_read: false,
          createdAt: data.created_at || new Date().toISOString()
        })

        notifyUser(data.title ?? 'Bạn có thông báo mới', {
          body: data.message
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.notification-dropdown {
  position: relative;

  .notification-trigger {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 50%;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .bell-icon {
      font-size: 18px;
      color: #ffffff;
    }

    .notification-badge {
      position: absolute;
      top: 8px;
      right: 8px;

      :deep(.el-badge__content) {
        background-color: #f56c6c;
        border: 2px solid #ffffff;
        font-size: 10px;
        height: 16px;
        line-height: 12px;
        min-width: 16px;
        padding: 0 4px;
      }
    }
  }
}

.notification-menu {
  padding: 0 !important;

  .notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #e4e7ed;
    background-color: #f8f9fa;

    .notification-title {
      font-weight: 600;
      font-size: 14px;
      color: #303133;
    }

    .mark-all-read-btn {
      color: #409eff;
      font-size: 12px;
      padding: 0;

      &:hover {
        color: #66b1ff;
      }
    }
  }

  .notification-list {
    max-height: 300px;
    overflow-y: auto;

    .notification-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 16px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #f5f7fa;
      }

      &.unread {
        background-color: #e6f7ff;
        border-left: 3px solid #409eff;

        &:hover {
          background-color: #d6f0ff;
        }

        .notification-message {
          font-weight: 600;
          color: #303133;
        }
      }

      &:last-child {
        border-bottom: none;
      }

      .notification-content {
        flex: 1;
        min-width: 0;

        .notification-message {
          font-size: 13px;
          color: #606266;
          line-height: 1.4;
          margin-bottom: 4px;
          word-wrap: break-word;
        }

        .notification-time {
          font-size: 11px;
          color: #909399;
        }

        a {
          margin-top: 4px;
          font-size: 14px;
          color: #909399;
          text-decoration: underline;
          z-index: 1000;
          cursor: pointer;
        }
      }

      .notification-actions {
        margin-left: 8px;

        .remove-btn {
          color: #c0c4cc;
          padding: 0;
          font-size: 12px;

          &:hover {
            color: #f56c6c;
          }
        }
      }
    }

    .empty-notifications {
      padding: 20px;
      text-align: center;

      :deep(.el-empty__description) {
        color: #909399;
        font-size: 12px;
      }
    }
  }

  .notification-footer {
    padding: 8px 16px;
    border-top: 1px solid #e4e7ed;
    background-color: #f8f9fa;
    text-align: center;

    .clear-all-btn {
      color: #909399;
      font-size: 12px;
      padding: 0;

      &:hover {
        color: #f56c6c;
      }
    }
  }
}

// Responsive design
@media (max-width: 768px) {
  .notification-dropdown {
    .notification-trigger {
      width: 36px;
      height: 36px;

      .bell-icon {
        font-size: 16px;
      }
    }
  }

  .notification-menu {
    width: 280px !important;

    .notification-list {
      max-height: 250px;
    }
  }
}
</style>
